export const EDITING_EXTENT_TYPES = {
	APPEARANCE: 'appearance',
	CONTENT: 'content'
}
